// extracted by mini-css-extract-plugin
export default {"logotag":"newheader_logotag__u8nQa","newBadge":"newheader_newBadge__7qMF5","newBadgeShine":"newheader_newBadgeShine__hbscY"};